import type { ReactElement } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Clogo } from '../Clogo';
import { Ctext } from '../Ctext';
export function InitialAuthHeader(): ReactElement {
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
        }}>
        <Clogo dataElScope="Cauthmodal/InitialAuthHeader" size={84} withText={false}/>

        <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '8px',
        }}>
          <Ctext size={25} weight={FontWeight.Medium} color={ColorType.White} opacity={1} style={{ letterSpacing: '1.2px' }}>
            Access
          </Ctext>
          <Ctext size={26} weight={FontWeight.Medium} color={ColorType.Accent} opacity={1} style={{ letterSpacing: '1.4px' }}>
            CABAL
          </Ctext>
        </div>

        <Ctext size={19} weight={FontWeight.Light} color={ColorType.White} opacity={0.7} style={{ marginTop: '-11px' }}>
          Identify. Then, take command.
        </Ctext>
      </div>
    );
}
